import { NgModule } from '@angular/core';

// Modules Material utilises

// Autres modules externes utilises 

// Modules metiers utilises

// Modules communs utilises

// Composants metiers

// Services metier
import { SecurityService } from './services/security.service';

@NgModule({
	imports: [
	],
	providers: [
		SecurityService,
	],
	declarations: [
	],
	exports: [
	]
})
export class SecurityModule {
	constructor() { }
}